import { render, staticRenderFns } from "./FmiForm.vue?vue&type=template&id=b479983a&scoped=true&"
import script from "./FmiForm.vue?vue&type=script&lang=js&"
export * from "./FmiForm.vue?vue&type=script&lang=js&"
import style0 from "./FmiForm.vue?vue&type=style&index=0&id=b479983a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b479983a",
  null
  
)

export default component.exports